import { ReactNode } from "react";

type SectionCardProps = {
  title?: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
};

export function SectionCard({ title, description, actions, children }: SectionCardProps) {
  return (
    <section
      className="overflow-hidden rounded-[10px] bg-[var(--surface)]"
    >
      {(title || description || actions) && (
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-[var(--border)] px-[18px] py-[14px]">
          <div>
            {title ? (
              <h3 className="text-[14px] font-semibold text-[var(--foreground)]">{title}</h3>
            ) : null}
            {description ? (
              <p className="mt-0.5 text-[12px] text-[var(--muted-foreground)]">{description}</p>
            ) : null}
          </div>
          {actions ? <div>{actions}</div> : null}
        </div>
      )}
      <div className="p-[18px]">{children}</div>
    </section>
  );
}
